import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import router from '@/router';
//import store from '@/store'
//import { getToken } from '@/utils/auth'
var Jump=false;
//var tips=false;
// create an axios instance
const service = axios.create({
  baseURL:'https://hmxzngl.km130.com', // url = base url + request url
 //baseURL:'http://www.e.com',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
// 节流
let lastTime = new Date().getTime()
service.interceptors.request.use(
  config => {
    // const nowTime = new Date().getTime()
    // if (nowTime - lastTime < 200) {
    //   return Promise.reject(new Error('节流处理中，稍后再试'))
    // }
    // lastTime = nowTime
    if (localStorage.getItem('Authorization')) {
      config.headers.Authorization = localStorage.getItem('Authorization');
    }
 
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      // Message({
      //   message: res.msg || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      Message({
        message: res.msg || 'error',
        type: 'info',
        duration: 5 * 1000
      })

      // if(!tips){
      //   Message({
      //   message: res.msg || 'no',
      //   type: 'info',
      //   duration: 5 * 1000
      // })
      // }
    //  50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 500 || res.code === 401 || res.code === 50014) {
        if(!Jump){
          Jump=true
          localStorage.removeItem('Authorization');
          localStorage.removeItem('uid');
          localStorage.removeItem('permission');
          setTimeout(() => {
            router.replace('/login');
          }, 1000);
        }
        // to re-login
        
        // MessageBox.confirm('登录已经已经过期', '重新登录', {
        //   confirmButtonText: '登录',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   // store.dispatch('user/resetToken').then(() => {
        //   //   location.reload()
        //   // })
         
          
        // })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service


// WEBPACK FOOTER //
// ./src/api/axiosFun.js